export const SEARCH_CONDITION_KEY = {
  PRODUCT_NAME: 'productName',
  PRODUCT_NUMBER: 'productNumber',
  ORDER_NUMBER: 'orderNumber',
  TRACKING_NUMBER: 'trackingNumber',
};
export const DEFAULT_SEARCH_CONDITION = {
  label: '상품번호',
  key: SEARCH_CONDITION_KEY.PRODUCT_NUMBER,
  value: '상품번호',
};
export const SEARCH_CONDITION = [
  DEFAULT_SEARCH_CONDITION,
  {
    label: '주문번호',
    key: SEARCH_CONDITION_KEY.ORDER_NUMBER,
    value: '주문번호',
  },
  {
    label: '송장번호',
    key: SEARCH_CONDITION_KEY.TRACKING_NUMBER,
    value: '송장번호',
  },
  {
    label: '상품명',
    key: SEARCH_CONDITION_KEY.PRODUCT_NAME,
    value: '상품명',
  },
];

export const SEARCH_CONDITION_FOR_BO = [
  DEFAULT_SEARCH_CONDITION,
  {
    label: '송장번호',
    key: SEARCH_CONDITION_KEY.TRACKING_NUMBER,
    value: '송장번호',
  },
  {
    label: '상품명',
    key: SEARCH_CONDITION_KEY.PRODUCT_NAME,
    value: '상품명',
  },
];
